import { Record as record } from 'immutable';
import _ from 'lodash';

import { resolve, construct, fields } from '../helpers/LinkMapper';
import Discount from './Discount';
import validation from '../validation';
import ValidationMixin from './ValidationMixin';

const defaults = {
    promoCode: null,
    discount: null,
    terms: null,
    discountType: null,
    validationError: null
};

class PromoCode extends record(defaults) {

    static fromJSON (json = {}) {
        return construct(PromoCode, json, {
            id: fields.string,
            discount: resolve.as(Discount),
            promoCode: fields.string,
            terms: fields.string,
            discountType: fields.string,
            validationError: fields.string
        });
    }

    getSchema () {
        return {
            promoCode: validation.requiredString()
        };
    }

    getParsedTerms() {
        return this.terms && this.terms.replace(/\n/g, '<br />');
    }

    isEmpty() {
        return _.isEmpty(this.promoCode);
    }
}

Object.assign(PromoCode.prototype, ValidationMixin);

export default PromoCode;
